import UpdateRetail from "components/ManageRetail/UpdateRetail";
import NotFooterLayout from "layouts/NotFooterLayout";
import { useLocation, useParams } from "react-router-dom";

function UpdateRetailPage() {
  const { id } = useParams<{ id: string }>();
  
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const section = searchParams.get('section') ?? '';
  const t = searchParams.get('t') ?? '';
  return (
    <>   
      <NotFooterLayout namePage="ข้อมูลลูกค้า"  >
        <div className="layout-content">
          <UpdateRetail id={id ?? "" } section={section} tabsKey={t}/>
        </div>
      </NotFooterLayout>
    </>
  );
}

export default UpdateRetailPage;
